import { render, staticRenderFns } from "./ProviderReports.vue?vue&type=template&id=32f5e2df&"
import script from "./ProviderReports.vue?vue&type=script&lang=js&"
export * from "./ProviderReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports